import { render, staticRenderFns } from "./approve-list.vue?vue&type=template&id=758b058b"
import script from "./approve-list.vue?vue&type=script&lang=js"
export * from "./approve-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports